function animateWhinNetwork(canvas, canvasType, width, height) {

	canvas.width = width;
	canvas.height = height;

	var ctx = canvas.getContext("2d");

	var TAU = 2 * Math.PI;

	const MAX_NUM_BALLS = 300;
	const MIN_NUM_BALLS = 50;

	var lineDistanceSquared = 0;
	var ballSpacing = 0;
	var ballSize = 0;
	var slowness = 0;
	var fillColor = "255, 255, 255";

	/* Set key values based on whether it's appearing in the foreground or the background: */
	if (canvasType === "foreground") {
		lineDistanceSquared = 100 * 100;
		ballSpacing = 65;
		ballSize = 4;
		slowness = 3;
		fillColor = "255, 255, 255";
	} else if (canvasType === "background") {
		lineDistanceSquared = 150 * 150;
		ballSpacing = 90;
		ballSize = 5;
		slowness = 12;
		fillColor = "220, 220, 230";
	}


	var times = [];
	function loop(newTime) {
		ctx.clearRect(0, 0, canvas.width, canvas.height);
		update(newTime);
		draw();
		requestAnimationFrame(loop);
	}

	function setOpacity(thingX, thingY) {
		var x = (thingX / canvas.width);
		var opacity = Math.abs(1 - x);
		return opacity;
	}

	function Ball (startX, startY, startVelX, startVelY) {
		this.x = startX || Math.random() * canvas.width;
		this.y = startY || Math.random() * canvas.height;
		this.vel = {
			x: ((startVelX || Math.random() * 2 - 1) / slowness),
			y: ((startVelY || Math.random() * 2 - 1) / slowness)
		};
		this.update = function(canvas, numFrames) {
			if (this.x > canvas.width + 50 || this.x < -50) {
				this.vel.x = -this.vel.x;
			}
			if (this.y > canvas.height + 50 || this.y < -50) {
				this.vel.y = -this.vel.y;
			}
			this.x += this.vel.x * Math.min(numFrames, 4);
			this.y += this.vel.y * Math.min(numFrames, 4);
		};
		this.draw = function(ctx, can) {
			ctx.beginPath();
			ctx.globalAlpha = .4;
			ctx.fillStyle = "rgba(" + fillColor + ", " + setOpacity(this.x, this.y) + ")";
			ctx.arc((0.5 + this.x) | 0, (0.5 + this.y) | 0, ballSize, 0, TAU, false);
			ctx.fill();
		}
	}

	var balls = [];
	let numBalls = Math.max(MIN_NUM_BALLS, Math.min(MAX_NUM_BALLS, canvas.width * canvas.height / (ballSpacing*ballSpacing)));
	for (var i = 0; i < numBalls; i++) {
		balls.push(new Ball(Math.random() * canvas.width, Math.random() * canvas.height));
	}

	var lastTime = null;
	function update(newTime) {
		var diff = (lastTime !== null) ? newTime - lastTime : 0;
		var numFrames = (diff < 16.667) ? 1 : Math.floor(diff / 16.667);

		for (var index = 0; index < balls.length; index++) {
			balls[index].update(canvas, numFrames);
		}
		lastTime = newTime;
	}

	function draw() {
		ctx.globalAlpha=1;
		ctx.fillStyle = "rgba(0, 0, 0, 0)";
		ctx.fillRect(0,0,canvas.width, canvas.height);
		for (var index = 0; index < balls.length; index++) {
			var ball = balls[index];
			ball.draw(ctx, canvas);
			ctx.beginPath();
			for (var index2 = balls.length - 1; index2 > index; index2 += -1) {
				var ball2 = balls[index2];
				const xDiff = (ball.x - ball2.x);
				const yDiff = (ball.y - ball2.y);
				var dist_squared = xDiff * xDiff + yDiff * yDiff;
				if (dist_squared < lineDistanceSquared) {
					ctx.strokeStyle = "rgba(" + fillColor + ", " + setOpacity(ball.x, ball.y) + ")";
					ctx.globalAlpha = 1 - (dist_squared > lineDistanceSquared ? .8 : dist_squared / lineDistanceSquared);
					ctx.lineWidth = "2px";
					ctx.moveTo((0.5 + ball.x) | 0, (0.5 + ball.y) | 0);
					ctx.lineTo((0.5 + ball2.x) | 0, (0.5 + ball2.y) | 0);
				}
			}
			ctx.stroke();
		}
	}

	// Start
	loop(performance.now());
}

export {animateWhinNetwork};